import { useEffect, useState } from "react"
import { toast } from "react-toastify";
import { useRequest } from "../Context/RequestContext";

const useProductsAdmin = (noAction = false) => {
    const [products, setProducts] = useState({
        current_page: 1,
        data: [],
        links: [],
        total: 0
    });
    const [loading, setLoading] = useState(false);
    const [loadingBtn, setLoadingBtn] = useState(false);
    const [modalShow, setModalShow] = useState(false)
    const { Request } = useRequest();
    const [search, setSearch] = useState()

    useEffect(() => {
        if (!noAction) {
            getProducts();
        }
        return () => {
            setProducts({
                current_page: 1,
                data: [],
                links: [],
                total: 0
            });
        }
    }, [])



    const getProducts = (url = '/admin/products') => {
        setLoading(true);
        Request({ url }).then((response) => {
            setLoading(false);
            if (response.status === 200) {
                setProducts(response.data);
            }
        })
    }

    const addProduct = (data) => {
        console.log(data)
        setLoadingBtn(true)
        Request({ url: '/admin/add-product', data }).then((response) => {
            setLoadingBtn(false)
            if (response.status === 200) {
                setModalShow(false);
                toast.success('محصول ثبت شد !')
                getProducts();
            } else {
                toast.error('محصول ثبت نشد لطفا اطلاعات را بررسی کنید !')
            }
        })
    }
    const removeProduct = (id) => {
        setLoading(true);
        Request({ url: '/admin/delete-product', data: { id } }).then((response) => {
            setLoading(false);
            if (response.status === 200) {
                toast.success('محصول حذف شد !')
                setProducts({ ...products, data: [...products.data].filter((product) => product.id != id) });
            }
        })
    }
    const onSearch = () => {
        setLoading(true);
        Request({ url: '/admin/products', data: { text: search } }).then((response) => {
            setLoading(false);
            if (response.status === 200) {
                setProducts(response.data);
            }
        });
    }

    return { loading, products, loadingBtn, removeProduct, addProduct, getProducts, setModalShow, modalShow, search, setSearch, onSearch }
}

export default useProductsAdmin